import type { SelectionExtensionPlugin } from '@atlaskit/editor-plugin-selection-extension/selection-extension-plugin-type';
import type { PublicPluginAPI } from '@atlaskit/editor-common/types/next-editor-plugin';

/**
 * Determines if the current selection is suitable for bulk create operations.
 * This function checks if multiple table rows are selected, which indicates
 * that the user wants to create multiple work items at once.
 *
 * @param editorAPI - Editor API
 * @returns true if the selection is for bulk create (multiple table rows), false otherwise
 */
export const isSelectionForBulkCreate = (
	editorAPI: PublicPluginAPI<[SelectionExtensionPlugin]> | null | undefined,
): boolean => {
	if (!editorAPI?.selectionExtension?.actions?.getSelectionAdf) {
		return false;
	}

	const selectionResult = editorAPI.selectionExtension.actions.getSelectionAdf();

	// Determine if multiple table rows are selected
	return (
		selectionResult?.selectedNodeAdf?.type === 'table' &&
		!!selectionResult?.selectionRanges &&
		selectionResult.selectionRanges.length > 1
	);
};
